
<template>
    <div class="py-2">
      <label class="block text-sm font-medium text-gray-700">{{label}}</label>
      <div class="block text-xs font-medium text-gray-700">{{info}}</div>
      <div class="mt-1">
        
        <div v-for="(option, index) in options" :key="index" class="pt-1">
            <div class="flex gap-1 w-full">
                <div class="w-[25px] py-1 ">{{index+1}}</div>
                <div class="w-full">
                    <input type="text" class="defaultInput w-full" :value="option.name" @blur="updateValue(index, $event.target.value)" />
                </div>
                <div v-if="index > 0">
                    <button @click="deleteOption(index)" class="secondaryButton flex gap-2">
                        <XMarkIcon class="h-5 w-5 text-gray-400"/>
                    </button>
                </div>
            </div>
        </div>           

        <div class="flex justify-end w-full pt-2">
            <button class="primaryButton_sm" @click="addOption">{{$t('buttons.add_variation')}}</button>
        </div>        

      </div>
    </div>
  </template>



<script>

import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
    name: "ArrayOptions",

    props: {
        label: {
            type: String,
            required: false
        },
        info: {
            type: String,
            required: false
        },        
        options: {
            type: Array,
            required: true
        }
    },

    methods: {
        addOption() {
            this.options.push({
                id: this.options.length + 1,
                name: '',
            });
        },
        deleteOption(index) {
            this.options.splice(index, 1);
        },
        updateValue(index, value) {
            this.options[index].name = value;
            
        }
    },

    components: {
        XMarkIcon
    },
    
}
</script>
